var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patient-payment-show"},[_c('payment-show',{attrs:{"medicalPaymentOriginalId":_vm.medicalPaymentOriginalId},on:{"cancel":_vm.goToListPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }